<rs-carousel [animationTime]="5">
    <ng-container *ngFor="let userComment of userComments">
        <app-card-comment
            [title]="userComment.title"
            [name]="userComment.name"
            [content]="userComment.content"
            [alt]="userComment.alt"
            [image]="userComment.img"
            [link]="userComment.link"></app-card-comment>
    </ng-container>
</rs-carousel>
